import {ResponsivePie} from '@nivo/pie'
import React from 'react'

export const BasePie = ({analyticsData}) => {
  const legends =
    analyticsData.length < 2
      ? undefined
      : [
          {
            anchor: 'bottom',
            direction: 'row',
            translateY: 56,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: '#999',
            symbolSize: 18,
            symbolShape: 'circle'
          }
        ]

  return (
    <ResponsivePie
      data={analyticsData}
      margin={{top: 40, right: 80, bottom: 80, left: 80}}
      innerRadius={0.5}
      padAngle={0.7}
      startAngle={-99}
      cornerRadius={1}
      colors={{scheme: 'nivo'}}
      borderWidth={1}
      borderColor={{from: 'color', modifiers: [['darker', 0.2]]}}
      radialLabelsSkipAngle={10}
      radialLabelsTextXOffset={6}
      radialLabelsTextColor="#333333"
      radialLabelsLinkOffset={0}
      radialLabelsLinkDiagonalLength={16}
      radialLabelsLinkHorizontalLength={24}
      radialLabelsLinkStrokeWidth={1}
      radialLabelsLinkColor={{from: 'color'}}
      slicesLabelsSkipAngle={10}
      slicesLabelsTextColor="#333333"
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      legends={legends}
    />
  )
}
